/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Artkrankenversicherung1Inputs */



/**

* @param {_Field_Artkrankenversicherung1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_artkrankenversicherung1 = /** @type {((inputs?: _Field_Artkrankenversicherung1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Artkrankenversicherung1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Art der Krankenversicherung")
});
export { _field_artkrankenversicherung1 as "_field_artKrankenversicherung" }